/*
 * @Author: zhangcx33595
 * @Date: 2021-06-18 18:43:39
 * @LastEditors: zhangcx33595
 * @LastEditTime: 2021-06-18 18:54:55
 * @FilePath: \openplat-web-inner\src\mixins\gioTrack.js
 */
export default {
  computed: {
    gioTrackAttr() {
      let { loginAccount } = this.$store.getters.uPlusUser || {};
      loginAccount = loginAccount || {}
      return {
        // appId_var:'',// 应用id，10021：课堂，10020：直播，5525：原门户
        routeName_var:this.$route.name,
        pageName_var: document.title,
        hsUserId_var: this.$store.getters.hsid || '-',
        customerName_var:this.$store.getters.user.customer&&this.$store.getters.user.customer.customer_name,
        deviceType_var:'Web',
        customer_account: loginAccount.customerAccountId || '',
        personal_account: loginAccount.personalAccountId || '',
        staff_account: loginAccount.staffAccountId || '',
        enterprise_account: loginAccount.enterpriseAccountId || '',
        enterpriseName: loginAccount.customerName || '',
        customer_no: loginAccount.customerNo || '',
        loginAccountId: loginAccount.accountId || '',
        loginAccountType: loginAccount.accountType || ''
      }
    }
  },
  methods: {
    // 统一处理埋点
    gioTrackEvent(id, obj = {}) {
      gdp('track', id, { ...this.gioTrackAttr, ...obj })
    }
  }
}



// WEBPACK FOOTER //
// ./src/gtn/mixins/gioTrack.js